export default {
  en: {
    somethingWrong: 'Something went wrong',
    retry: 'Try again',
    writeSupport: 'Contact support',
    loading: 'Loading',
  },
  ru: {
    somethingWrong: 'Что-то пошло не так',
    retry: 'Обновить',
    writeSupport: 'Написать в поддержку',
    loading: 'Загрузка',
  },
  de: {
    somethingWrong: 'Etwas ist schiefgelaufen',
    retry: 'Erneut versuchen',
    writeSupport: 'Support kontaktieren',
    loading: 'Wird geladen',
  },
  pt: {
    somethingWrong: 'Algo deu errado',
    retry: 'Tentar de novo',
    writeSupport: 'Falar com o suporte',
    loading: 'Carregando',
  },
  fr: {
    somethingWrong: 'Une erreur est survenue',
    retry: 'Réessayer',
    writeSupport: 'Contacter le support',
    loading: 'Chargement',
  },
  es: {
    somethingWrong: 'Algo salió mal',
    retry: 'Reintentar',
    writeSupport: 'Contactar con soporte',
    loading: 'Cargando',
  },
};
